import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=5baac25a&scoped=true&"
import script from "./CustomSelect.vue?vue&type=script&lang=ts&"
export * from "./CustomSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=5baac25a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baac25a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VIcon,VSelect})
